import { AfterViewInit, Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { AbstractComponent } from './shared/components/abstract-component';
import { AuthService } from './services/auth.service';
import '@angular/localize/init';
import { AppNotificationService } from './shared/services/app-notification.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent extends AbstractComponent implements OnInit, AfterViewInit {
  title = 'SEDMS-KendoUI';
  userLoaded: Subject<boolean> = new Subject<boolean>();
  user: any;
  authResult: any;
  public isDialogVisible: boolean = false;
  showDetails = false;
  location = window.location.href;
  referrer = document.referrer;
  userAgent = navigator.userAgent;
  screenResolution = `${screen.width}x${screen.height}`;
  @ViewChild('notificationContainer', { read: ViewContainerRef })
  public notificationContainer: ViewContainerRef

  constructor(
    private authService: AuthService,
    private notificationService: AppNotificationService
  ) {
    super();
  }

  ngOnInit() {
    this.authService.completeAuthentication();
  }
  
  ngAfterViewInit() {
    this.notificationService.setNotificationContaier(this.notificationContainer);
  }

  public openDialog(): void {
    this.isDialogVisible = true;
  }

  public closeDialog(): void {
    this.isDialogVisible = false;
    this.showDetails = false;
  }

  toggleDetails(event: Event) {
    event.preventDefault();
    this.showDetails = !this.showDetails;
  }

  afterOnDestroy(): void {
    // afterOnDestroy
  }
}
